import { Navigate } from '@sorare/routing';
import { ANY_SPORT_MARKET_SHOP_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const RedirectToInstantBuyPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MARKET_SHOP_INSTANT_BUY)}
      keepSearchParams
    />
  );
};

export default RedirectToInstantBuyPage;
